import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {useStatsTimelineStore} from '../../stats-timeline-store'
import CardViewSVG from './svg/card-view.svg'
import TableViewSVG from './svg/table-view.svg'

const TwView = tw.div<{selected: boolean}>`
  bg-header-old
  rounded
  h-34
  border
  border-solid
  ${p =>
    p.selected
      ? 'border-action-default text-third-old'
      : 'border-bg-header-old text-obscure-old'}
`

export const Toggle = observer(() => {
  const [state, store] = useStatsTimelineStore()

  return (
    <>
      {
        <div className="flex self-start mt-4">
          <button className="mr-8" onClick={() => store.toggleView('card')}>
            <TwView selected={state.view === 'card'}>
              <CardViewSVG />
            </TwView>
          </button>
          <button className="mr-14" onClick={() => store.toggleView('table')}>
            <TwView selected={state.view === 'table'}>
              <TableViewSVG />
            </TwView>
          </button>
        </div>
      }
    </>
  )
})
